import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { move2 } from '~/actions/rawMaterial';
import Title from '~/components/Title';
import MultiPickerCount from '~/components/MultiPickerCount';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import LocationPicker from '~/components/LocationPicker';
import ContainerPicker from '~/components/ContainerPicker';
import OrPicker from '~/components/OrPicker';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

const LocationOrContainerPicker = OrPicker({
  location: LocationPicker,
  container: ContainerPicker,
});

const MultiRawMaterialPicker = MultiPickerCount(RawMaterialPicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  submit() {
    move2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.rawMaterials,
      this.state.from,
      this.state.to,
    )
      .then(() => this.context.dialogClose(this.props.dialogId));
  }

  render() {
    return (
      <div className={[styleDialog.background, style[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Title style={{ marginBottom: '10px' }}>Move RawMaterial</Title>
              <div className={style.row}>
                <div className={style.title}>RawMaterial</div>
                <div className={style.field}>
                  <MultiRawMaterialPicker
                    value={this.state.rawMaterials}
                    onChange={rawMaterials => this.setState({ rawMaterials })}
                  />
                </div>
              </div>
              <div className={style.row}>
                <div className={style.title}>From</div>
                <div className={style.field}>
                  <LocationOrContainerPicker
                    value={this.state.from}
                    onChange={from => this.setState({ from })}
                  />
                </div>
              </div>
              <div className={style.row}>
                <div className={style.title}>To</div>
                <div className={style.field}>
                  <LocationOrContainerPicker
                    value={this.state.to}
                    onChange={to => this.setState({ to })}
                  />
                </div>
              </div>
              <Button
                style={{ marginTop: '10px' }}
                primary
                raised
                label="move"
                type="submit"
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  location: state.getIn(['locations', 'locations', props.data.id]) && state.getIn(['locations', 'locations', props.data.id]).toJS()
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/RawMaterialMove/index.js